module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Half-heart-15ec75f72a5caafd3ecca94174194721.svg";